
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1317Dialog extends Serenity.EntityDialog<Report_1317Row, any> {
        protected getFormKey() { return Report_1317Form.formKey; }
        protected getIdProperty() { return Report_1317Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1317Row.localTextPrefix; }
        protected getNameProperty() { return Report_1317Row.nameProperty; }
        protected getService() { return Report_1317Service.baseUrl; }
        protected getDeletePermission() { return Report_1317Row.deletePermission; }
        protected getInsertPermission() { return Report_1317Row.insertPermission; }
        protected getUpdatePermission() { return Report_1317Row.updatePermission; }

        protected form = new Report_1317Form(this.idPrefix);

    }
}